import { Avatar } from '@/components/ui/avatar';
import { Badge, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { MENTION_AVATAR_SIZE } from './mentionCardStyle';

interface MentionCardCreatorRowProps {
  username?: string;
  profilePictureUrl?: string;
  timeAgo: string | null;
  isAffiliate: boolean;
  affiliateLabel: string;
}

const MentionCardCreatorRow: React.FC<MentionCardCreatorRowProps> = ({
  username,
  profilePictureUrl,
  timeAgo,
  isAffiliate,
  affiliateLabel,
}) => {
  return (
    <Flex alignItems="center" gap={2} minW={0} flex="1">
      <Avatar
        boxSize={MENTION_AVATAR_SIZE}
        size="xs"
        src={profilePictureUrl || undefined}
        name={username || 'Creator'}
        colorPalette="primary"
        flexShrink={0}
        outline="1px solid"
        outlineColor="blackAlpha.100"
        outlineOffset="-1px"
      />
      <VStack alignItems="flex-start" gap={0.5} minWidth={0} flex={1}>
        <HStack gap={1.5} minW={0} w="full">
          <Text
            fontFamily="heading"
            fontSize="xs"
            fontWeight="semibold"
            color="dark"
            lineClamp={1}
            lineHeight="short"
            minW={0}
          >
            {username}
          </Text>
          {isAffiliate && (
            <Badge
              size="xs"
              colorPalette="green"
              variant="subtle"
              flexShrink={0}
              title={affiliateLabel}
            >
              {affiliateLabel}
            </Badge>
          )}
        </HStack>
        <Text fontSize="11px" color="primary.400" lineHeight="short" whiteSpace="nowrap">
          {timeAgo}
        </Text>
      </VStack>
    </Flex>
  );
};

export default MentionCardCreatorRow;
